var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92268 1.52798C10.2607 1.18992 10.7193 1 11.1973 1C11.6754 1 12.134 1.18992 12.472 1.52798C12.8101 1.86605 13 2.32456 13 2.80265C13 3.28075 12.8101 3.73926 12.472 4.07732L4.39912 12.1502L1 13L1.84978 9.60088L9.92268 1.52798Z",
    stroke: "#39996B",
    strokeWidth: 1.17358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.200c66a2f979a61fa7dda654455bcbca.svg";
export { ForwardRef as ReactComponent };